import Vue from "vue";
import Vuex from "vuex";

// modules
import criteria from "./modules/criteria";
import subcriteria from "./modules/subcriteria";
import menu from "./modules/menu";
import content from "./modules/content";
import review from "./modules/review";

Vue.use(Vuex);

const state = {
  hak: null,
  snackbar: {
    visibility: false,
    color: "primary",
    text: null
  }
};

const actions = {
  setSnackbar({ commit }, payload) {
    commit("SET_SNACKBAR", payload);
  },
  setHak({ commit }, payload) {
    commit("SET_HAK", payload);
  }
};

const getters = {
  snackbar: state => state.snackbar,
  isAuth: state => state.hak !== null,
  isAdmin: state => state.hak === parseInt(process.env.VUE_APP_HAK_ADMIN),
  isReviewer: state => state.hak === parseInt(process.env.VUE_APP_HAK_REVIEWER),
  isWriter: state => state.hak === parseInt(process.env.VUE_APP_HAK_WRITER)
};

const mutations = {
  SET_SNACKBAR(state, payload) {
    state.snackbar = payload;
  },
  SET_HAK(state, payload) {
    state.hak = payload;
  }
};

export default new Vuex.Store({
  actions: actions,
  getters: getters,
  modules: {
    menu,
    criteria,
    subcriteria,
    content,
    review
  },
  mutations: mutations,
  state: state
});
